import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
    ...zhLocale,
	model:{
		messagemin:'请确认完成基本信息录入',
	},
    header: {
        p1: "亲爱的客户:",
        p2: "如有任何疑问，请于办公时间内致电。",
        p3: "客户服务专线:",
        p3_ph: "(853) 3971 6988",
        p4: "免费内地专线:",
        p4_ph: "400 1206 046",
        p5: "办公时间:上午9:00 - 下午6:00",
        p6: "星期六、星期日及香港公众假期休息",
        p7: "华亚金融集团官方微信"
    },
    allpage: {
		qtxbtxadd: "请输入住宅地址",
        qtxbtx: "请填写必填项",
        ts30mintj: "请于30分钟内提交开户申请，超时将不会保留申请人所填写的开户信息。",
        queding: "确   定",
        tishi: "提   示",
        syserr: "服务器异常！",
        pleasechecknet: "请求失败，请检查网络！",
        wrongfile: "上传错误,文件格式必须为：png/jpg/jpeg",
        filesizeeror: "文件上传失败，图片大于2M",
        xiuxintime: "休息时间不可选！",
        yuyuesize: " 預約人數已滿請選擇其他時間段",
        kfcx: "客服查询"
    },
    tabbar: {
        jbxx: "基本信息",
        sgzk: "受雇状况",
        cwzk: "财务状况",
        khsm: "客户声明",
        fxpg: "风险评估",
        wjsc: "上传文件",
        ktzh: "开通账户",
        yykh: "预约开户"
    },
    login: {
		email:'電郵',
		verificationcode:'验证码',
		fullname:'姓名',
		telephone:'电话号码',
		plaletelephone:'请输入电话号码',
		plaletelephoneweb:'请输入电话号码',
		plaletelephones:'请输入电话号码',
		submit:'提交',
		submits:'提 交',
		khname:'请确认完成所有信息录入，再继续下一页。',
        khtitle: '开立证券账户',
        khbutton: "开   户",
        yanzhengma: "获取验证码",
        phoneinput: "请输入手机号",
        vcodeinput: "请输入验证码",
        jiaoxue: "线上开户教学",
        khzb: "开户准备",
        idcard: "身份证",
        pass: "护照",
        bankcard: "银行卡",
        aftersecond: "s后获取",
        regetcode: "重新获取",
        quhaop: "请选择区号！",
        phoneinputp: "请输入手机号!",
        errormsg: "服务器异常！",
        failmsg: "请求失败，请检查网络！",
        vscodep: "请输入验证码！",
        success: "登录成功！",
        failmsgw: "阿欧，出错了！",
        tongyip: "请先阅读并同意开户协议后重试！",
        yjydbty: "已经阅读并且同意",
        khxyhz: "开户协议",
        yuedukhxyhz: "阅读开户协议",
        zgdl: "中国",
        zgxg: "中国香港",
        zgam: "中国澳门",
        adly: "澳大利亚",
        jnd: "加拿大",
        mlxy: "马来西亚",
        mg: "美国",
        xjp: "新加坡",
        xxl: "新西兰",
        yg: "英国"

    },
    khxy: {
        khzhxy: "客户综合协议",
        tygxy: "同意该协议",
        loading: "正在努力为您加载客户协议"
    },
    khlx: {
        khlx: "开户类型",
        lxxz: "类型选择",
        gr: "个人",
        zhzl: "账户种类",
        xjzh: "现金账户",
        dydz: "电邮地址",
        dydzinput: "请输入有效的电邮地址",
        errordydzinput: "请输入有效的电邮地址",
        ktdzjyfw: "电子交易服务",
        shi: "开启",
        fou: "关闭",
        qscselfphoto: "请上传自拍图片",
        picjzz: "加载中",
        choose1: "选择拒绝在直接促销中使用个人资料",
        choose4: "华亚证券本身可能会使用阁下的个人资料作直接促销。如阁下不希望华亚证券本身在直接促销中使用阁下的个人资料，请在此项左边的方格内加上剔号(“✔️”)",
        choose5: "以上代表阁下目前就是否希望收到直接促销联系或资讯的选择，并取代阁下于本申请前向华亚证券传达的任何选择。",
        choose6: "本人(等)明白可以随时通过华亚证券指定的渠道要求更改有关之设定。",
        xiayibu: "下一步"
    },
    jbxx: {
        grxinx: "个人信息",
        zwxm: "中文姓名",
        ywxm: "英文姓名",
        qshurzhongwenm: "请输入中文名",
        qshruyingwenming: "请输入英文名",
        cal: "称呼",
        xiansheng: "先生",
        nvshi: "女士",
        qxzchenghu: "请选择称呼",
        birth: "出生日期",
        jiaoyuchengdu: "教育程度",
        qxzjycd: "请选择教育程度",
        jiaoyuchengdushi: "您的教育程度是？",
        xiaoxuehuoyixia: "小学程度或以下",
        zhongxuechengdu: "中学程度",
        ftzw: '繁體中文',
        jtzw: '简体中文',
        yingwen: 'English',
        daxuehuoyishang: "预科或大学程度（大学程度或以上）",
        fjsm1: "客户同伴/多一位员工安排（并不适用于客人年龄为65岁或以下，或教育程度为小六以上）由于本人(等)是：",
        zhangzhe: "长者（66岁或以上）",
        jiaoyuchengduxiaoliu: "教育程度为小六或以下",
        khtbap: "客戶同伴安排",
        fjsm2: "本人(等)确认及明白本人(等)有权利带同同伴在整个开立华亚证券有限公司(「下称华亚」)交易帐户过程中陪同本人(等)明白华亚证券交易帐户协议书的所有内容、投资所涉及的风险和有关的费用及收费",
        lable3: "本人(等)因此希望能带同同伴，并确认及证实",
        fjsm3: "「下称同伴」与本人(等)之关系为",
        fjsm4: "，在此过程中陪同本人(等)，而同伴之年龄为18至65岁、中学教育程度或以上、流利于讲解过程中使用的语言及拥有协助本人(等)明白所有相关文件所需的知识及经验。",
        fjsm5: "本人(等)确认华亚曾强烈要求本人(等)带同同伴出席本会晤以完全明白所有相关文件的内容及证券投资所涉及的风险。惟本人(等)确认本人(等)在毋须同伴参与的情况下亦有能力明白上述的事项。",
        lable4: "多一位员工安排（必须在香港办事处或深圳代表处进行）",
        fjsm8: "本人(等)确认及明白本人(等)有权利选择多一位华亚持牌中介人办理此开立交易账户过程以增加对本人(等)的保障。",
        fjsm6: "本人(等)因此希望多一位华亚持牌中介人办理此过程，并确认过程如是进行。（额外中介人名称",
        zhiwei: "职位",
        fjsm7: "尽管本人(等)有权利选择，本人(等)确认本人(等)不需要有多一位华亚持牌中介人处理此过程。",
        queding: "确定",
        quxiao: "取消",
        qingshurutbxm: "请输入同伴姓名",
        qingtianxie: "请填写",
        tanxiefjsm: "请填写附加声明",
        fjsm: "附加声明",
        sfxx: "身份信息",
        sfzmwjzl: "身份信息",
        qxzsfzmwjzl: "请选择身份证明文件种类",
        xgjmsfz: "香港居民身份证",
        gnrssfz: "国内人士身份证",
        hzhfxgsfz: "护照或非香港居民身份证",
        sfz: "身份证号码",
        huzhao: "护照",
        gj: "国籍",
        swbh: "税务编号",
        bsdq: "报税地区",
        rmyswbh: "如没有提供税务编号",
        causeA: "理由A-账户持有人的居留司法管辖区并没有向其民发出税务编号。",
        causeB: "理由B-账户持有人不能取得税务编号。如选这一理由，解释账户持有人不能取得税务编号的原因。",
        causeC: "理由C-账户持有人无须提供税务编号。居留司法管辖区的主机关不需要披露。",
        qxzwftgswbhdly: "请选择无法提供税务编号的理由",
        chooseB: "如果选取理由B，解释账户持有人不能取得税务编号的原因",
        zzdz: "住宅地址",
        djwl: "单据往来",
        djyyxz: "单据语言",
        danjuways: "选择下列一种方式发送成交单据正本（买卖确认）及对账单（如客户选用邮寄方式，将每月收取纸张结单及行政费10美金）",
        dydz: "电邮地址",
        bscdz: "住宅地址",
        yhzh: "香港银行账户",
        yhmc: "银行名称",
        zhmc: "账户名称",
        zhhm: "账户号码",
        fz1: "附注：收款账户名称必须与交易账户名称相同，否则开户将不被接纳。",
        qsrsfzhm: "请输入身份证号码",
        qsrhzhm: "请输入护照号码",
        qsrgj: "请输入国籍",
        qsrswbh: "请输入税务编号",
        qsrbsdq: "请输入报税地区",
        qsrly: "请输入不能取得税务编号的理由",
        qsrzjdz: "请输入住宅地址（不接受邮政信箱）",
        qxzdjyy: "请选择单据语言",
        qxzdjwldz: "请选择单据往来地址",
        qsryhmc: "请输入香港银行名称",
        qsrzhmc: "请输入账户名称",
        qsrzhhm: "请输入账户号码",
        qxuanzeriqi: "请选择日期",
        swbhjstitle: "税务编号说明",
        swbhjs1: "港税务居民/中国税务居民，税务编号是香港居民身份证号码/中国居民身份证号码。",
        swbhjs2: "香港/中国以外的税务居民，则需填写税务管辖地区及税务编号。如未能提供税务编号，必须填写合适理由。",
		swbhj1:'香港身份证号码输入所有英文字母及括弧内数字（无需输入括弧符号）例如：A1234567。',
		swbhj2:'内地身份证号码输入所有数字及英文字母。',
		swbhj3:'护照或非香港居民身份证号码输入所有数字及英文字母（无需输入符号）例如：AB123Y。',
        xiayibu: "下一步"
    },
    sgzk: {
        sglx: "受雇类型",
        sg: "受雇",
        zg: "自雇",
        tx: "退休",
        qt: "其他",
        gsmc: "公司名称",
        gsxz: "业务性质",
        guzhu: "请输入公司名称",
        qsrgz: "请输入雇主",
        ywxz: "请选择或输入业务性质",
        zhiwei: "职位",
        xuzzhiwei: "请选择或输入职位",
        xuzzhiweie: "请输入职位",
        gujiahuodiqu: "国家或地区",
        qingxuangjhdq: "请选择或输入国家或地区",
        qsrsgsj: "请选择受雇时间",
        qsrzgzk: "请输入自雇状况",
        qsrqtzk: "请输入其他状况",
        xiayibu: "下一步",
        ywxz1: "汽车",
        ywxz2: "金融/经济自营商",
        ywxz3: "政府/公关",
        ywxz4: "农业、林业及渔业",
        ywxz5: "采矿及采石",
        ywxz6: "制造业",
        ywxz7: "电力及燃气供应",
        ywxz8: "自来水，污水处理，废弃物管理",
        ywxz9: "建造业",
        ywxz10: "进出口贸易、批发及零售业",
        ywxz11: "运输、仓库、邮政及速递",
        ywxz12: "酒店及饮食业",
        ywxz13: "信息及通讯",
        ywxz14: "地产业",
        ywxz15: "法律及会计",
        ywxz16: "广告及市场",
        ywxz17: "行政及支持服务",
        ywxz18: "教育",
        ywxz19: "医疗",
        ywxz20: "服务活动",
        xuzzhiwei1: "见习生",
        xuzzhiwei2: "主任",
        xuzzhiwei3: "董事",
        xuzzhiwei4: "经理",
        xuzzhiwei5: "总监",
        xuzzhiwei6: "助理",
        xuzzhiwei7: "首席执行总监",
        xuzzhiwei8: "总经理",
        xuzzhiwei9: "副总裁",
        xuzzhiwei10: "部门经理",
        xuzzhiwei11: "区域经理",
        qingxuangjhdq1: "中国",
        qingxuangjhdq2: "中国香港",
        qingxuangjhdq3: "中国澳门",
        qingxuangjhdq4: "马来西亚",
        qingxuangjhdq5: "新加坡",
        qingxuangjhdq6: "澳洲",
        qingxuangjhdq7: "英国",
        qingxuangjhdq8: "美国",
        qingxuangjhdq9: "加拿大",
        qingxuangjhdq11: "新西兰",
        qingxuangjhdq10: "中国台湾",
        sgsj: "受雇时间",
        qxztztime: "请选择"
    },
    cwzk: {
        cwzk: "财务状况",
        mnsr: "每年收入（HKD）",
        zcjz: "资产净值（HKD）",
        zjly: "资金来源",
        chuxu: "储蓄",
        jiating: "家庭",
        yyyl: "营业溢利",
        zjsr: "租金收入",
        daikuan: "贷款",
        qita: "其他",
		qtzi:'其他',//资金来源
        zjlyother: "请填写其他资金来源",
        tzmb: "投资目标",
        tzmbsm: "阁下在下方的选择将决定能获准交易的产品，请选取适用选项",
        zbzz: "资本增值",
        touji: "投机",
        zhuanqushouru: "赚取收入",
        duichong: "对冲",
        tzmbother: "请填写其他投资目标",
        tzmbotherww: "其他",//投资目标
        planother: "其他",//投资计划
        inputplanother: "请填写其他投资计划",
        tzjh: "投资计划",
        shijianduoxuan: "时间",
        duanqi: "短期",
        zhongqi: "中期",
        changqi: "长期",
        timeother: "请输入时间",
        tzjy: "投资经验",
        touzijingyanxuanze: "请选择投资经验",
        sszq: "上市证券",
        years: "年数",
        year: "年",
        over10year: "大于10年",
        yscp: "衍生产品",
        qhqq: "期货或期权",
        jijin: "基金",
        zhaiquan: "债券",
        wtzjy: "无投资经验",
        tzjyother: '其他',//"请填写投资经验"
        qxztztime: "请选择投资年数",
        qxzmnsr: "请选择每年收入",
        qxzzcjz: "请选择资产净值",
        qxzzjly: "请选择资金来源",
        qsrqtzjly: "请选择其他资金来源",
        qxztzmb: "请选择投资目标",
        qsrqttzmb: "请填写其他投资目标",
        qxztzjh: "请选择投资计划",
        qsrqttzjh: "请填写其他投资计划",
        qxztzjy: "请选择投资经验",
        qsrqttzjy: "请填写其他投资经验",
        xiayibu: "下一步"
    },
    khsm: {
		messagea:'',
		messageb:'',
		messagec:'',
		messaged:'',
        khsm: "客户声明",
        qxzshf: "请选择是或否",
        qscgzsmtytp: "请上传雇主书面同意书图片",
        q1: "1.你是否此账户的最终实益拥有人？",
        shi: "是",
        foutigxx: "否（请申明以下资料）",
        mingcheng: "名称",
        mingchenginput: "请输入名称",
        idcardpassnum: "身份证/护照号码",
        idcardpassnuminput: "请输入身份证/护照号码",
        address: "通讯地址",
        addressinput: "请输入通讯地址",
        q2: "2.你是否与华亚证券有限公司，其母公司或关联公司之雇员代理人有亲属关系？",
        shitigxx: "是（请提供详情）",
        fou: "否",
        guyudailirenname: "雇员代理人名称",
        guyudailirennameinput: "请输入雇员代理人名称",
        guanxi: "关系",
        guanxiinput: "请输入关系",
        q3: "3.你是否证监会注册的持牌法团或注册机构，或其他金融机构的雇员或代理人？",
        jigoumincheng: "机关机构名称",
        jigouminchenginput: "请输入机关机构名称",
        guzhushumiantongyi: "阁下雇主的书面同意",
        shangchuantupian: "(上传图片)",
        dianjixuanzetupian: "点击选择上传图片",
        tupianmiss: "图片走丢了",
        q4: "4.你是否上市公司之董事或股东，外国的公众人物，例如政府高官、政党领袖、宗教领袖等或其家人？",
        qingtigongxiangqing: "请提供详情",
        q5: "5.你是否于华亚证券持有其他账户（包括有关人士持有之账户）？",
        accountnum: "账户号码",
        accountnuminput: "请输入账户号码",
        accountname: "账户名称",
        accountnameinput: "请输入账户名称",
        q6: "6.你是否美国公民或就税务目的而言的居民（由于美国税收申报要求，美国人账户需要特别审批）？",
        querenjiqianshu: "客户协议",
        qianshu1: "载于本账户申请书（「申请书」）的资料均属真是及准确。 你有责任在生效后七（7）个工作日內通知华亚证券有关资料的任何重大改变。 华亚证券有权随时联络任何人， 包括客户的银行， 经纪或信贷机构， 藉以核实本申请书上的资料。",
        qianshu1a: "本人谨此承诺并确认：",
        qianshu2: "a.本人已收到华亚证券以本人选择的语言（英文或中文）所提供的",
        qianshu3: "， 并已阅读及明白协议书内之条款",
        qianshu3a: "「（包括其附表、附录及附件（如有）」",
        qianshu3b: "，而本人接纳并同意受该等条款约束；",
        qianshu4: "「证券交易账户协议书（「协议书」）」",
        qianshu1b: "b.本人确认:",
        qianshu1c: "已按照本人选择的语言(英文或中文)获提供",
        qianshu5: "「风险披露声明」",
        qianshu2a: "；及已获邀阅读载于协议书中的风险披露声明，提出问题及征求独立意见（如本人有此意愿）。",
        qianshu2b: "c.本人已阅读载于协议书中有关",
        qianshu6: "「个人资料（私隐）条例」",
        qianshu2c: "的客户通知， 并明白及同意华亚证券私隐政策的条款； 及",
        qianshu61: "《交易帳戶協議書補充》",
        qianshu7: "d.本人已阅读及明白附表A中现金账户之附加条款（如开立现金账户）， 及／或附表B中电子交易服务之附加条款（如选择电子交易服务）， 并同意这些条款的约束。",
        qianshu8: "e.本人声明及同意以下:",
        qianshu8a: "本人知悉签名样式作为本人签字记录，日后华亚证券可凭本人此签名式样执行各种指示，本人会就该等指示负上全部责任。已签署 (i) ",
        qianshu9: "「W-8BEN」表格",
        qianshu10: "，声明并非「美国人士」，并作买卖美股之用 (如适用)。(ii) ",
        qianshu11: "「个人税务居民自我证明表格CRS-I (HK) 」 表格",
        qianshu12: "，并同意遵守有关条款及相关法律责任。",
        xiayibu: "下一步",
        nxyrzydxy: "您需要详细阅读并同意以下附件内的客户协议及私隐政策。",
        bryydbtykhxy: "本人已阅读并同意客户协议及私隐政策。",
        qydplease: "请阅读附件内的客户协议及私隐政策。",
    },
    fxpg: {
        qxzyx: "请选择一个选项",
        fxpg: "填写评估问卷",
        title: "本《风险承受能力问卷》旨在了解您的一般个人状况，及评价您作为投资者整体上对投资风险的一般态度。只有阁下能够决定那种程度的风险回报能令您安心，透过本问卷可助您评价自己面对风险的承受能力。",
        q1: "Q1.您的年龄是介乎于？",
        q2: "Q2.您的教育程度是?",
        q2A: "A.小学程度或以下",
        q2B: "B.中学程度",
        q2C: "C.预科或大学程度",
        q3: "Q3.您有多少年投资于价值波动之投资产品的经验（包括购入然后长期持有及经常买卖投资产品）？价值会波动的投资产品的例子包括股票，单位信托基金，外币，商品，结构投资产品，认股权证（俗称《窝轮》），期权，期货，投资相连保单等。",
        q3A: "A.没有经验或小过一年",
        q3B: "B.一至三年",
        q3C: "C.多过三年",
        q4: "Q4.您是否有以下任何产品的投资经验或知识？（您可选择多于一个选项）",
        q4A: "A.现金，存款，存款证，保本产品，香港政府债券。",
        q4B: "B.股票，债券，股票或债券基金（包括强积金，不包括货币市场基金），投资相连保单。",
        q4C: "C.期权，期货，认股权证（俗称《窝轮》），对冲基金，其他挂钩票据，场外交易股份。",
        q5: "Q5.在一段时间之内，投资价值可升可跌，我们称之为波动。一般而言，风险越高的投资，其潜在波动越大，但潜在回报亦越高。相反，风险越低的投资，其潜在波动越小，但潜在回报亦相对较低。在一般情况下，您会愿意投资于波动程度多大的投资产品。",
        q5A: "A.波动多于-30%至+30%之间",
        q5B: "B.波动于-30%至+30%之间",
        q5C: "C.波动于-15%至+15%之间",
        q6: "Q6.您有多需要将投资项目变现，来满足对突发事件的流动资金需要？",
        q6A: "A.我不一定会出售任何投资。",
        q6B: "B.我会出售不多于30%的投资。",
        q6C: "C.我会出售多于30%但少于50%的投资。",
        q6D: "D.我会出售50%以上的投资。",
        q7: "Q7.在一般情况下，投资的年期越长，承受的风险越高，而投资产品的价值亦会波动。当投资于产品时，您会愿意接受下列哪项投资年期？有关投资产品的例子，请查阅问题4。",
        q7A: "A.多过三年",
        q7B: "B.一至三年",
        q7C: "C.小过一年",
        sumscore: "总分数",
        xiayibu: "下一步",
        mzsm: "免责声明",
        mzsm1: "1.本问卷的结果是从您向华亚证券（本公司）提供的数据，并根据若干普遍接纳的假设及合理估算而得出的，本问卷采用的方法及取值仅供说明",
        mzsm2: "用途，本公司对本问卷所戴数据及/或所得结果的准确性或完整性并不负责或承受任何法律责任。",
        mzsm3: "2.本问卷及所得结果仅供您参考，并非购买或出售任何金融产品及服务的要约或招揽，亦不应被视为投资意见或推荐。",
        mzsm4: "3.请注意，倘若您未能全面披露所有或任何有关您的个人状况（如财务状况），不正确，不完整或过时的数据可能影响本集团评价您对投资风险的",
        mzsm5: "态度及承受能力，如您的状况出现变动而可能影响本问卷中任何问题的答案，我们极力建议您再次填写本问卷。",
        fxcsnlfx: "风险承受能力分析",
        fxcscd: "风险承受程度",
        dfx: "低风险",
        zfx: "中风险",
        gfx: "高风险",
        tzzdybtz: "投资者的一般特征",
        bsx: "保守型",
        phx: "平衡型",
        jqx: "进取型",
        fx1: "阁下愿意承受低度的风险，也明白会接受比较保守回报。",
        fx2: "阁下愿意承受中度的风险，于中长线换取潜在回报。",
        fx3: "阁下愿意承受高度的风险，于长线换取最大的潜在回报。阁下亦明白到有可能招致损失大部份或全部本金。",
        nxyrzydxy: "您需要详细阅读并同意以下附件内的客户协议及私隐政策。"
    },
    wjsc: {
        sflx: "身份类型",
        type1: "香港居民",
        type2: "国内人士",
        type3: "外国人士",
        scdzzmwj: "上传地址证明文件",
        zmwjshuoming: "请提供下列三项其中一项证明（最近三个月）并清楚显示申请人姓名及地址，并在下方将文件上传至本公司。",
        zmwj1: "（一）信用卡或银行卡结单",
        zmwj2: "（二）电话收费单",
        zmwj3: "（三）水/电/煤气收费单",
        piclimit: "照片文件大小不能超过2M",
        djsctupian: "点击选择上传图片",
        djzmtp: "(单据证明图片)",
        scxgsfzzfm: "上传香港居民身份证正/背面",
        xgsfztp0: "(香港居民身份证正面图片)",
        xgsfztp1: "(香港居民身份证背面图片)",
        tupianmiss: "图片走丢了",
        scsfzzfm: "上传身份证正/背面",
        sfzzm: "(身份证正面图片)",
        sfzfm: "(身份证背面图片)",
        scxgtxzzfm: "上传香港通行证正/背面",
        xgsfzzm: "(香港通行证正面图片)",
        xgsfzfm: "(香港通行证背面图片)",
        xiayibu: "下一步",
        schz: "上传护照",
        hztp: "(护照图片)",
        a1: "请上传地址证明图片",
        a2: "请上传香港身份证正面图片",
        a3: "请上传香港身份证背面图片",
        a4: "请上传身份证正面图片",
        a5: "请上传身份证背面图片",
        a6: "请上传香港通行证正面图片",
        a7: "请上传香港通行证背面图片",
        a8: "请上传护照正面图片"
    },
    ktzh: {
		qmisent: "QMIS Securities Limited - Clients' Account",
		qmisents: "华亚证券有限公司-客户账号",
		hkopen:'上传文件完成',
		hkbs:'请选择开通证券账户方式',
        khfs: "开户方式",
        qtgzzfs: "转账至本公司收款银行的客户户口。",
        qmis: "华亚证券有限公司",
        qmisclient: "华亚证券有限公司",
        type1: "邮递开户",
        type2: "预约时间",
        type3: "支票开户",
        zzje: "转账金额",
        hdbzhb: "或同等币值的货币，",
        skyh: "收款银行",
        hfyh: "香港上海汇丰银行有限公司",
        jsbz: "接受币种",
        zhhm: "账户号码",
        yhdz: "银行地址",
        skyhdh: "收款银行代号",
        skhkmc: "收款户口名称",
        dzhb: "（港元及外币）",
        dzmy: "（港元及美元）",
        address1: "香港中环皇后大道中一号",
        zsyybdfk: "（只适用于本地付款）",
        zgxtyh: "中国信托商业银行股份有限公司香港分行",
        address2: "香港中环金融街八号 国际金融中心二期28楼",
        zgyh: "中国银行(香港)有限公司",
        gangyuan: "（港元）",
        waibi: "（外币）",
        rmbjmy: "（人民币及美元）",
        address3: "香港中环花园道一号中银大厦",
        gyyz: "中国工商银行(亚洲)有限公司",
        address4: "香港中环花园道三号中国工商银行大厦33楼",
        sczzsj: "上传转账收据",
        dianjixuanzetupian: "点击选择上传图片",
        zzsjtp: "(转账收据图片)",
        tupianmiss: "图片走丢了",
        qsczzsj: "请上传转账收据，本公司查核后，会于两个工作天内致电阁下确认。",
        qlyyxsy: "请留意以下事宜",
        sy1: "1. 只接受通过与开户申请人之名称相同之香港银行账号进行转账。",
        sy2: "2. 转账之账号须与提供之银行账号相同。",
        sy3: "3. 银行收取的跨行转账及电汇费用将由客户支付并从存款金额中扣除。",
        sy4: "4. 存入方式仅限转账 (网上银行或柜台)，不接受现金存入等其他方式。",
        sy5: "5. 转账收据上必须显示客户姓名、客户银行账号、转账金额及本公司之银行账号。",
        yyrq: "预约日期",
        yysj: "预约时间",
        zpxmzyxyq: "支票需符合以下要求",
        yq1: "1. 支票签发人须与开户申请人之名称相同。",
        yq2: "2. 支票账号须与提供之银行账号相同。",
        yq3: "3. 金额不得少于港币10,000元或同等币值。",
        yq4: "4. 收款人为“华亚证券有限公司”。",
        yq5: "5. 支票上的签名须与开户表格上的签名相同。",
        yq6: "6. 支票须为香港持牌银行所发行。",
        apyjdyxdz: "请安排邮递支票到本公司以下地址",
        dz1: "华亚证券有限公司",
        dz2: "香港上环德辅道中199号无限极广场21楼2104室",
        dz3: "（信封面注明：客户服务部收）",
        qxzyyrq: "请选择预约日期",
        qxzyysj: "请选择预约时间",
        qsczzsjtp: "请上传转账收据图片",
        xiayibu: "完成",
        hsyh: "恒生银行有限公司",
        address5: "香港德辅道中 83 号",
        ydkh1: "请依以下程序完成开户申请：",
        ydkh2: "列印",
        ydkh3: "本申请文件",
        ydkh4: "在申请文件内签署栏提供签字式样",
        ydkh5: "准备以下文件副本",
        ydkh6: "A.身份证 / 护照正背面",
        ydkh7: "B.最近三个月之住址证明",
        ydkh8: "C.银行月结单",
        ydkh9: "安排见证人在申请表格及相关文件副本上填上姓名及签署",
        ydkh10: "经以下其中一项途径把款项发送到本公司",
        ydkh11: "A.通过银行转账方式，把不少于港币 10,000 或同等币值之金额，转账到本公司收款银行账号，有关转账要求请",
        ydkh12: " ( 按此 )",
        ydkh13: "1.只接受通过与开户申请人名称相同的香港银行账号进行转账。",
        ydkh14: "2.转账的账号要与提供之银行账号相同",
        ydkh15: "3.如进行跨行转账，银行可能会收取相关手续费。",
        ydkh16: "4.存入方式仅限转账（网上银行或柜台），不接受现金存入等其他方式。",
        ydkh17: "5.转账收据上必须显示客户姓名、客户银行账号、转账金额及本公司的银行账号。",
        ydkh18: "B.签发不少于港币 10,000 或同等币值金额的支票，有关支票要求请",
        ydkh19: "1.支票签发人与开户申请人的名称相同",
        ydkh20: "2.支票账号与提供的银行账号相同",
        ydkh21: "3.金额不得少于港币 10,000 元或同等币值",
        ydkh22: "4.收款人为“华亚证券有限公司”",
        ydkh23: "5.支票上的签名与开户表格上的签名相同",
        ydkh24: "6.支票须为香港持牌银行所发行",
        ydkh25: "请安排把以上文件邮递到本公司以下地址",
        warning_left: "当前可预约日期为3个月",
        warning_right: "香港公众假期"
    },
    khfinish: {
        success: "提交成功",
        dearuser: "亲爱的客户",
        f1: "感谢您提交开户申请，我们会尽快与您联络。",
        f2: "如有任何疑问，请于办公时间内致电：",
        f3: "客户服务专线",
        f4: "免费內地专线",
        f5: "您已提交开户申请。",
        f6: "如有任何查询，请于办公时间内致电",
        f7: "感谢您提交",
        f8: "开户申请，我们会尽快与您联络。",
        t1: "感谢您提交网上开户申请，我们会尽快与您联络。",
        t2: "感谢您提交预约开户申请，我们会尽快与您联络。",
        t3: "感谢您提交支票开户申请，我们会尽快与您联络。",
        t4: "感谢您提交邮递开户申请，我们会尽快与您联络。"
    }


};
export default cn;